import manifest from "../generated/promotion-images.json";
import { resolvePreparedMediaAsset } from "./publicMediaUrl";
import { promotionCandidates } from "./promotionResponsive";

export function resolvePromotionSources(sourceUrl, surfaceKey) {
  if (surfaceKey !== "promotion.page-banner") return [];
  const candidates = promotionCandidates(sourceUrl);
  // Keep release-local URLs identical in server HTML and the first client render.
  if (candidates.length) return candidates;
  const prepared = resolvePromotionAvif(sourceUrl, surfaceKey);
  return prepared ? [{ url: prepared }] : [];
}

// Only exact, versioned promotion sources prepared with this release are used.
// All other sources keep their normal public media contract and fallback chain.
export function resolvePromotionAvif(sourceUrl, surfaceKey, assets = manifest.entries) {
  if (surfaceKey !== "promotion.page-banner") return "";
  const entry = resolvePreparedMediaAsset(assets, sourceUrl);
  if (!entry || !/^\/static\/promotions\/[a-f0-9]{24}\.avif$/.test(entry.path)) return "";
  return entry.path;
}
